/**
 * Marker activation rules.
 *
 * MapLibre toggles a marker's popup from TWO places: `Marker._onKeyPress` on
 * the element (Enter/Space) and `Marker._onMapClick` on the map (any click
 * whose target is inside the marker element). CABAL markers now use the
 * span-based Cbutton path: its keyboard activation invokes the action without
 * dispatching a second DOM click, leaving MapLibre's keypress as the single
 * popup toggle.
 *
 * The two are told apart by `MouseEvent.detail`, which is the click count for
 * pointer activation and 0 for a click the platform synthesized from a key.
 * Kept here, pure, so the distinction is asserted rather than buried in a
 * listener.
 */

/** `MouseEvent.detail` for a click synthesized by the platform or code. */
const SYNTHESIZED_CLICK_DETAIL = 0;

export function isKeyboardSynthesizedClick({ detail }: { detail: number }): boolean {
  return detail === SYNTHESIZED_CLICK_DETAIL;
}
